export default function getTooltipValue(value) {
  if (value === -1 || value === null) return 0;
  if (isNaN(value) || Number.isInteger(value)) return value;
  return Number(value).toFixed(2);
}
